import { render, staticRenderFns } from "./CompassNew.vue?vue&type=template&id=06515059&scoped=true&"
import script from "./CompassNew.vue?vue&type=script&lang=ts&"
export * from "./CompassNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06515059",
  null
  
)

export default component.exports